import { z } from "zod";

/** Native mailbox reads for people; these contracts never select agent work. */
export const MailboxFolderSchema = z.enum(["all", "inbox", "sent", "spam", "bounced"]);
export const MailboxPageInputSchema = z.strictObject({
  folder: MailboxFolderSchema.default("all"),
  search: z.string().trim().max(200).default(""),
  continuation: z
    .string()
    .min(3)
    .max(4100)
    .regex(/^c:.+$/u)
    .nullable()
    .default(null),
});
export type MailboxPageInput = z.input<typeof MailboxPageInputSchema>;

const MailboxRowSchema = z.strictObject({
  ref: z.string().regex(/^[1-9]\d*$/u),
  folder: z.string(),
  sender: z.string(),
  subject: z.string(),
  receivedAt: z.iso.datetime({ offset: true }),
  bisonUrl: z.url().nullable(),
});
export const MailboxPageSchema = z.strictObject({
  rows: z.array(MailboxRowSchema),
  continuation: MailboxPageInputSchema.shape.continuation,
});
export type MailboxPage = z.infer<typeof MailboxPageSchema>;
export const MailboxMessageSchema = MailboxRowSchema.extend({
  text: z.string(),
  html: z.string().nullable(),
  to: z.array(z.string()),
  cc: z.array(z.string()),
  attachments: z.array(z.string()),
});
export type MailboxMessage = z.infer<typeof MailboxMessageSchema>;
